import(/* webpackMode: "eager", webpackExports: ["AmplifyConfigure"] */ "/codebuild/output/src4172242104/src/helloero-new/packages/helloero/src/app/AmplifyConfigure.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4172242104/src/helloero-new/packages/shared/components/functional/GlobalScripts/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JotaiProvider"] */ "/codebuild/output/src4172242104/src/helloero-new/packages/shared/components/functional/JotaiProvider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserInfoProvider"] */ "/codebuild/output/src4172242104/src/helloero-new/packages/shared/hooks/useUserInfo.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4172242104/src/helloero-new/packages/tailwind_config/globals.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4172242104/src/helloero-new/packages/tailwind_config/customs.css");
